module.exports = "/_next/static/images/Trend01Visual@2x-e3c2aa6d6c1999af9ae8255956062c56.webp";